import styled from 'styled-components';

export default styled.div`
    font-size: 0.8rem;

    .client-error {
        color: ${({ theme }) => theme.colors.error};
        font-size: 1rem;
    }
`;
